import { Itsme, Keyboard, QRCode } from '@frontend/icons';
import { CommonMessage } from '@frontend/lang';
import { FormattedMessage, useIntl } from 'react-intl';

import { MethodButton } from '../../components/method-button/method-button';
import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import usePickUpMethod from './pick-up-method.controller';

const ID = 'pick-up-method';

const PickUpMethod = () => {
    const intl = useIntl();
    const viewProps = usePickUpMethod();

    return (
        <WizardScreenContainer
            id={ID}
            header={{ title: CommonMessage.BUTTONS.PICK_UP }}>
            <div className='text-always-black w-full text-base font-medium'>
                <FormattedMessage
                    id='kiosk.wizard.pick-up-method.instructions'
                    description='Instructions for pick-up method selection'
                    defaultMessage='Please choose one of the options to continue your pick-up'
                />
            </div>

            <div className='flex flex-col items-start justify-start gap-2 self-stretch'>
                {viewProps.pinStep && (
                    <MethodButton
                        label={intl.formatMessage({
                            defaultMessage: 'Input PIN-code',
                            id: 'kiosk.wizard.pick-up-method.input-pin',
                            description: 'Label for button to input PIN-code manually'
                        })}
                        icon={<Keyboard className='text-always-black size-5' />}
                        onClick={() => viewProps.onContinue(viewProps.pinStep)}
                    />
                )}
                {viewProps.scanStep && (
                    <MethodButton
                        label={intl.formatMessage({
                            defaultMessage: 'Scan QR-code',
                            id: 'kiosk.wizard.pick-up-method.scan-qr',
                            description: 'Label for button to scan QR code'
                        })}
                        icon={<QRCode className='text-always-black size-5' />}
                        onClick={() => viewProps.onContinue(viewProps.scanStep)}
                    />
                )}
                {viewProps.itsmeStep && (
                    <MethodButton
                        label={intl.formatMessage({
                            defaultMessage: 'Login with itsme',
                            id: 'kiosk.wizard.method-select.login-itsme',
                            description: 'Label for button to login with itsme'
                        })}
                        icon={<Itsme className='text-always-black size-5' />}
                        onClick={() => viewProps.onContinue(viewProps.itsmeStep)}
                    />
                )}
            </div>
        </WizardScreenContainer>
    );
};

export default PickUpMethod;
